import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";
import { Separator } from "../elements/Separator";
import { ArrowCircleIcon } from "../icons/ArrowCircleIcon";

export const Unlock: React.FC<{
  title?: string | null;
  heading?: string | null;
  message?: IRichTextInformation | null;
  image?: IGatsbySvg | null;
  internalLink?: string | null;
}> = ({ title, heading, message, internalLink, image }) => {
  const arrowIcon = (
    <ArrowCircleIcon
      colourClassName="text-hyacinth"
      className="h-38px -rotate-90 transform-gpu"
    />
  );
  return (
    <section data-component="Unlock" className="py-section bg-cyan text-coal">
      <div className="page-grid max-width relative">
        {title && (
          <h2
            className={classNames(
              "h3",
              "col-span-4 col-start-2 row-start-1",
              "md:col-span-4 md:col-start-2",
              "lg:col-span-4 lg:col-start-3",
            )}
          >
            {title}
          </h2>
        )}
        {heading && (
          <h3
            className={classNames(
              "p2",
              "col-span-4 col-start-2 row-start-2",
              "md:col-span-4 md:col-start-2",
              "lg:col-span-6 lg:col-start-3",
            )}
          >
            {heading}
          </h3>
        )}
        {internalLink && (
          <Link
            className={classNames(
              "self-center justify-self-end",
              "col-span-1 col-start-5 row-span-2 row-start-1",
              "md:col-span-1 md:col-start-9",
              "lg:col-span-1 lg:col-start-14",
            )}
            to={internalLink}
          >
            {arrowIcon}
          </Link>
        )}

        <Separator
          colorClass="text-hyacinth"
          className={classNames(
            "col-span-4 col-start-2 row-start-3",
            "md:col-span-8 md:col-start-2",
            "lg:col-span-13 lg:col-start-3",
          )}
        />
        {message && (
          <RTF
            content={message}
            className={classNames(
              "self-center",
              "col-span-4 col-start-2 row-start-4",
              "md:col-span-8 md:col-start-2",
              "lg:col-span-6 lg:col-start-3",
              "text-hyacinth",
            )}
            fixedParagraphClassName="h3"
          />
        )}
        {image && (
          <img
            src={image.encoded ?? image.encodedUrl}
            alt=""
            className={classNames(
              "self-center",
              "col-span-4 col-start-2 row-start-5",
              "md:col-span-6 md:col-start-3",
              "lg:col-span-6 lg:col-start-10 lg:row-start-4",
            )}
          />
        )}
      </div>
    </section>
  );
};
